import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

export type AccessType = 'login' | 'logout';

@Injectable({ providedIn: 'root' })
export class AccessEventsService {
  private accessSubject = new Subject<AccessType>();
  readonly onAccess = this.accessSubject.asObservable();

  login() {
    this.accessSubject.next('login');
  }

  logout() {
    this.accessSubject.next('logout');
  }
}
